import {Component, inject, Input, OnDestroy} from "@angular/core";

import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {Subject} from "rxjs";
import {Location} from "@angular/common";
import {Router} from "@angular/router";
import {MainViewStore} from "src/app/presentation/main-view/main-view.store";

@Component({
    template: ``,
    standalone: false
})
export abstract class AssetComponent implements OnDestroy {

  @Input() loading: boolean = true

  protected destroy$: Subject<void> = new Subject<void>();
  protected mainViewStore = inject(MainViewStore);
  protected router = inject(Router);

  private location = inject(Location);

  protected constructor(
    protected dataSynchronisationService: DataSynchronisationService,
    protected dataSubscriptionService: DataSubscriptionService,
    protected viewportService: ViewportService) {
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  protected back(): void {
    this.location.back();
  }

  protected close() {
    this.mainViewStore.hideChildComponent();
  }
}
